const sortByField = <T>(items: T[], field: keyof T): T[] => {
  return [...items].sort((a, b) => String(a[field]).localeCompare(String(b[field])))
}

export default sortByField
